import { Box } from '@chakra-ui/react'
import { FC, useEffect, useMemo } from 'react'

import useReabTypeVeichule from '@hook/parametrization/use-reab-typeveichule'
import useAuth from '@hook/shared/use-auth'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import LayoutEmpty from '@component/Layout/Empty'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import LayoutTools from '@component/Layout/Tools'
import SelectedTableBarReabTypeVeichule from '@component/Parameterization/ReabTypeVeichule/SelectedTableBar'

const ParametrizationReabTypeVeichule: FC = () => {
  const { menuToggle } = useLayout()
  const {
    loading,
    headers,
    data,
    filename,
    pagination,
    filters,
    fetching,
    query,
    tableInteraction,
    companieId,
    actions,
    getData,
    getCenters,
    setFilename,
    setQuery
  } = useReabTypeVeichule()
  const { companies: authCompanies } = useAuth()

  const { hasSessions } = useSessions()
  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 225px)'
          : 'calc(100vh - 193px)'
        : hasSessions
        ? 'calc(100vh - 366px)'
        : 'calc(100vh - 334px)',
    [menuToggle, hasSessions]
  )

  useEffect(() => {
    getCenters()

    if (authCompanies?.length === 1) {
      getData(authCompanies[0])
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box mW={400}>
      <LayoutTools
        title={filename}
        filters={filters}
        actions={actions}
        query={query}
        onSearchChange={setQuery}
        onTitleChange={setFilename}
        isDisabled={loading || fetching || data.length === 0}
      />
      <SelectedTableBarReabTypeVeichule />

      {loading ? (
        <LayoutLoader
          title="Recuperando informações..."
          message="Aguarde enquanto buscamos os dados no banco de dados"
        />
      ) : authCompanies?.length === 0 ? (
        <LayoutEmpty
          type="chartEmpty"
          title="É necessário pelo menos 1 empresa cadastrada no perfil"
          message=""
        />
      ) : authCompanies?.length > 1 && companieId === '' ? (
        <LayoutEmpty
          type="chartEmpty"
          title="Selecione ao menos 1 empresa"
          message="Filtre sua busca em cima para obter informações"
        />
      ) : data.length === 0 ? (
        <LayoutEmpty
          title="Nada encontrado!"
          message="Filtre sua busca ao lado para obter informações"
        />
      ) : (
        <Box>
          <Box paddingLeft={2}>
            <GridQuantity data={data} />
          </Box>

          <TableGrid
            id="purschase-table"
            headers={headers}
            query={query}
            data={data}
            itsSortable={true}
            loading={fetching}
            actions={tableInteraction}
            height={tableHeight}
            pagination={pagination}
          />
        </Box>
      )}
    </Box>
  )
}

export default ParametrizationReabTypeVeichule
